// ABOUTME: The warehouse-locations TopRow cards (pick/bulk in-use + grade), extracted as standalone components
// ABOUTME: so each can be reused on the locations page and dropped individually into a BI dashboard cell.
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import PercentOutlinedIcon from "@mui/icons-material/PercentOutlined";
import TakeoutDiningOutlinedIcon from "@mui/icons-material/TakeoutDiningOutlined";
import UnarchiveOutlinedIcon from "@mui/icons-material/UnarchiveOutlined";
import Text from "../../../../../components/theme/text/Text";
import Heading from "../../../../../components/theme/text/Heading";
import ShDoubleTextSkeleton from "../../../../../components/theme/skeleton/ShDoubleTextSkeleton";
import { tokens } from "../../../../../theme";

// The four cards key into one `useGetDashboardWarehouseLocationTotalsQuery` payload by `type` (passed as `data`).
export const locationChartStates = {
    pickInUse: "pickInUse",
    pickGrade: "pickGrade",
    bulkInUse: "bulkInUse",
    bulkGrade: "bulkGrade"
}

// Generic location KPI card: a coloured "in use" (x / y) or grade value with a logo chip.
export const LocationDashboardCard = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    const calculateValueComp = () => {
        if (props.value && props.type.includes("InUse")) {
            const valueSplitted = props.value.split("/");

            return (
                <Box sx={{
                    display: "flex",
                }}>
                    <Heading
                        className={cx('', {
                            'active': props.active
                        })}
                        sx={{
                            pt: 0.5,
                            color: `${colors.pastel.light[props.color][600]} !important`,
                            "&.active": {
                                color: `${colors.pastel.light[props.color][600]} !important`
                            }
                        }}
                    >
                        {valueSplitted[0].trim()}
                    </Heading>
                    <Heading
                        className={cx('', {
                            'active': props.active
                        })}
                        sx={{
                            pt: 0.5,
                            color: colors.txt["secondary"],
                            color: `${colors.pastel.light[props.color][600]} !important`,
                            "&.active": {
                                fontWeight: "normal",
                                color: `${colors.pastel.light[props.color][600]} !important`
                            }
                        }}
                    >
                        &nbsp;/ {valueSplitted[1].trim()}
                    </Heading>
                </Box>
            )
        }
        return (

            <Heading
                className={cx('', {
                    'active': props.active
                })}
                sx={{
                    pt: 0.5,
                    color: `${colors.pastel.light[props.color][600]} !important`,
                    "&.active": {
                        color: `${colors.pastel.light[props.color][600]} !important`
                    }
                }}
            >
                {props.value}
            </Heading>
        )
    };

    return (
        <Box
            className={cx('', {
                'active': props.active,
            })}
            sx={{
                flex: 1,
                // background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                background: theme.palette.mode === "dark" ? colors.pastel.light[props.color][100] : colors.pastel.st[props.color][100],
                border: `1px solid ${colors.pastel.light[props.color][200]}`,

                borderRadius: 4,
                padding: 3,
                display: "flex",
                alignItems: "center",

                ".logo-box": {
                    width: 40,
                    height: 40,
                    borderRadius: 2,
                    background: colors.pastel.st[props.color][200],
                    color: colors.txt["primary"],
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    "& .logo": {
                        fill: colors.pastel.st[props.color][600],
                    }
                },

                // "&.active": {
                //     background: colors.pastel.light[props.color][100],
                //     ".logo-box" : {
                //         background: colors.pastel.light[props.color][200],
                //         "& .logo, & .logo path" : {
                //             fill: colors.pastel.light[props.color][600],
                //         }
                //     },
                // },
                "@media screen and (max-width: 47.9375em)": {
                    p: 2,
                    // flexDirection:"row",
                    // justifyContent:"space-between",
                    ".logo-box": {
                        width: 32,
                        height: 32,
                    }

                },
                ...props.sx,

            }}
        >
            <Box
                sx={{
                    // "@media screen and (max-width: 47.9375em)" : {
                    //     order:2
                    // }

                }}
            >
                <Box className="logo-box">
                    {props.logo}
                </Box>
            </Box>
            {props.isLoading || !props.data ?
                <ShDoubleTextSkeleton />
                :
                <Box
                    sx={{
                        pl: 2,
                        display: "flex",
                        flexDirection: "column",
                        "@media screen and (max-width: 47.9375em)": {
                            // pl:1,
                        }
                    }}
                >
                    <Text light noBreak>{t(props.type)}</Text>
                    {calculateValueComp()}
                </Box>
            }
        </Box>
    )
}

// Baked per-metric cards — each fixes logo / type / colour and derives `value` from the totals payload.
const LocationsCard = ({ data, isLoading, isFetching, active, type, color, logo, sx }) => (
    <LocationDashboardCard
        logo={logo}
        isLoading={isLoading || isFetching}
        data={data}
        value={data?.[type]}
        type={type}
        displayType={"text"}
        color={color}
        active={active}
        sx={sx}
    />
);

export const LocationsPickInUseCard = (props) => (
    <LocationsCard {...props} type="pickInUse" color="brown" logo={<TakeoutDiningOutlinedIcon className="logo" />} />
);
export const LocationsPickGradeCard = (props) => (
    <LocationsCard {...props} type="pickGrade" color="brown" logo={<PercentOutlinedIcon className="logo" />} />
);
export const LocationsBulkInUseCard = (props) => (
    <LocationsCard {...props} type="bulkInUse" color="lightblue" logo={<UnarchiveOutlinedIcon className="logo" />} />
);
export const LocationsBulkGradeCard = (props) => (
    <LocationsCard {...props} type="bulkGrade" color="lightblue" logo={<PercentOutlinedIcon className="logo" />} />
);
